// =====================================================
// 📁 PendingQuotationsList.tsx
// =====================================================

import PendingQuotationCard from './PendingQuotationCard';

interface Props {
  quotations: any[];

  navigateOnContinue?: boolean;
}

const PendingQuotationsList: React.FC<Props> = ({
  quotations,
  navigateOnContinue = false,
}) => {
  return (
    <div className="space-y-3">
      {quotations.map((quotation) => (
        <PendingQuotationCard
          key={quotation.id}
          quotation={quotation}
          navigateOnContinue={navigateOnContinue}
        />
      ))}
    </div>
  );
};

export default PendingQuotationsList;
